module.exports = __webpack_public_path__ + "img/xmasParty6.c4f52767.jpg";